export default __webpack_public_path__ + "static/media/event2.f0c41660.jpg";